/** Thrown when the chat SSE stream ends with an `error` event (HTTP may still be 200). */
export class ChatStreamFailure extends Error {
  readonly hadContent: boolean;

  constructor(message: string, hadContent: boolean) {
    super(message);
    this.name = 'ChatStreamFailure';
    this.hadContent = hadContent;
  }
}

/** Marks an interrupt/drop so the UI keeps already-rendered answer deltas. */
export function toChatStreamFailure(error: unknown, hadContent: boolean): ChatStreamFailure {
  if (error instanceof ChatStreamFailure) {
    return error.hadContent || !hadContent
      ? error
      : new ChatStreamFailure(error.message, true);
  }

  const message = error instanceof Error ? error.message : 'Chat stream interrupted';

  return new ChatStreamFailure(message, hadContent);
}
